// FassalkartAI - Agricultural AI Platform
// Firebase Configuration
// Collections: mandiPrices (price data), ki_* (all FassalkartAI collections)

import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Validate required config keys at startup
const missingKeys = Object.entries(firebaseConfig)
  .filter(([key, val]) => !val && key !== 'measurementId')
  .map(([key]) => key);

if (missingKeys.length > 0) {
  console.error('[Firebase] Config missing keys:', missingKeys);
}

let app, db, auth, storage;

try {
  app = initializeApp(firebaseConfig);
  db = initializeFirestore(app, {
    cache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  });
  auth = getAuth(app);
  storage = getStorage(app);

  // ── App Check ────────────────────────────────────────────────────────────
  // Disabled: reCAPTCHA key not yet registered in Firebase App Check console.
  // To enable: register REACT_APP_RECAPTCHA_SITE_KEY in Firebase Console →
  // App Check → Web → reCAPTCHA v3, then uncomment below.
  //
  // const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  // if (recaptchaSiteKey && process.env.NODE_ENV === 'production') {
  //   try {
  //     initializeAppCheck(app, {
  //       provider: new ReCaptchaV3Provider(recaptchaSiteKey),
  //       isTokenAutoRefreshEnabled: true,
  //     });
  //   } catch (_) {}
  // }
} catch (e) {
  console.error('[Firebase] Init failed:', e.message);
}

// ── Auth session persistence: keep user logged in across browser restarts ───
if (auth) {
  setPersistence(auth, browserLocalPersistence).catch(err =>
    console.warn('[Firebase] auth persistence failed:', err)
  );
}

// Analytics only in environments that support it (not SSR/Node)
export let analytics = null;
isSupported().then(yes => {
  if (yes && app) {
    analytics = getAnalytics(app);
  }
}).catch(() => {});

export { app, db, auth, storage };
export default app;
